import { schema } from "normalizr";

export const round = new schema.Entity(
  "rounds",
  {},
  { idAttribute: "savedGameId" },
);
